// WARN: The bundled vendor.esbuild.js is also used by PinmetoAdmin, be careful to update!

// Below files generate vendor.min.js in Grunt.
require('../../_shared/vendor/polyfill/HTMLCanvasElement_ToBlob.js');
require('../../_shared/vendor/polyfill/custom-event-polyfill.js');
window.numeral = require('../../_shared/vendor/numeral.min.js');

window.moment = require('moment/dist/moment.js');

require('html2canvas');
require('cropperjs');
require('angular');
require('angular-route');
require('angular-sanitize');
require('angular-animate');
require('angular-ui-router');
require('angular-gettext');
require('angular-dynamic-locale');
require('angular-local-storage');
require('ng-file-upload');

require('angular-moment');
require('angular-moment-picker/dist/angular-moment-picker.min');
require('angular-websocket');
require('re-tree');

require('angular-numeraljs/dist/angular-numeraljs.min');
require('ui-select');
require('ng-device-detector');

import i18next from 'i18next';
window.i18next = i18next;

import i18nextHttpBackend from 'i18next-http-backend';
window.i18nextHttpBackend = i18nextHttpBackend;
import 'ng-i18next';

// Below files are included in index.template.html
window.global = window; // To solve the `global is not defined in socket.io-client`
window.io = require('socket.io-client');

import 'leaflet';
import 'leaflet.markercluster';
